module.exports = __webpack_public_path__ + "static/media/anatomia.b4583689.png";